import { useRutilusQuery } from '../../../../../../api/graphql/useRutilusQuery';
import { Heading } from '../../../../../../components/Heading/Heading';
import { LoadingSpinner } from '../../../../../../components/LoadingSpinner/LoadingSpinner';
import { PostsViewerTouchDevice } from '../../../../../../components/PostsViewer/components/PostsViewerTouchDevice/PostsViewerTouchDevice';
import { useClientHasRendered } from '../../../../../../helpers/hooks';
import {
  GetSingleCatchForViewer,
  GetSingleCatchForViewerVariables,
} from '../../../../../../interfaces/graphql';
import { getSingleCatchForViewer } from '../../../../../../queries/rutilus/Catches';
import { useExplore } from '../../../../context/ExploreContext';
import { MapDrawerLayout } from '../../MapDrawerLayout';
import { MapDrawerNotification } from '../../MapDrawerNotification/MapDrawerNotification';

interface IProps {
  catchId: string;
}

export const CatchView = ({ catchId }: IProps) => {
  const { saveParamsInUrl } = useExplore();
  const { loading, data } = useRutilusQuery<
    GetSingleCatchForViewer,
    GetSingleCatchForViewerVariables
  >(getSingleCatchForViewer, {
    variables: { externalId: catchId },
  });
  const clientHasRendered = useClientHasRendered();

  if (clientHasRendered && !data && loading) {
    return (
      <MapDrawerLayout>
        <LoadingSpinner loadingText="Loading catch..." />
      </MapDrawerLayout>
    );
  }

  if (!data) {
    return (
      <MapDrawerLayout>
        <div className="flex h-full flex-col">
          <div className="flex">
            <Heading variant="sm" className="pr-2">
              Catch
            </Heading>
          </div>
          <MapDrawerNotification title="It looks like something went wrong" />
        </div>
      </MapDrawerLayout>
    );
  }

  const catchPostForViewer = data.catch.post;
  const handleOnClose = (): void => {
    saveParamsInUrl({ drawerView: 'catches', drawerViewId: undefined });
  };

  return (
    <MapDrawerLayout
      className="h-full overflow-hidden overflow-y-auto !p-0 pb-4"
      withCloseButton={false}
      fullHeight={false}
    >
      <PostsViewerTouchDevice
        posts={[catchPostForViewer]}
        currentPostId={catchPostForViewer._id}
        setCurrentPostId={async () => void {}}
        hasMore={false}
        loadMore={() => {}}
        onClose={handleOnClose}
        inMapDrawer
      />
    </MapDrawerLayout>
  );
};
